import { Component, OnInit, Input, HostListener } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ModalController, Platform } from '@ionic/angular';
@Component({
  selector: 'app-product-brands',
  templateUrl: './product-brands.page.html',
  styleUrls: ['./product-brands.page.scss'],
})
export class ProductBrandsPage implements OnInit {
  @Input() product: any;
  constructor(private platform: Platform,public db: DataService, public modal: ModalController) { }

  ngOnInit() {
    // console.log(this.product)
    // console.log(this.db.get_product_brands)
    this.db.get_product_brands.map(res => {
      res.selected = this.check_selected(res)
    })

    const modalState = {
      modal : true,
      desc : 'fake state for our modal'
    };
    history.pushState(modalState, '');

  }

  @HostListener('window:popstate', ['$event'])
  dismissModal() {
    this.modal.dismiss();
  }

  check_selected(data) {
    let d = 0
    if (this.product.product_brands != undefined)
      this.product.product_brands.map(res => {
        res.brand == data.name ? d = 1 : null
        // console.log( res.brand == data.name ?  d = 1 : null)
      })

    return d
  }

  save_value() {
    let d: any = [];
    let v = this.db.get_product_brands;
    v.map(res => {
      if (res.selected) {
        let y = {
          brand: res.name,
          brand_name: res.brand_name,
          parentfield: "product_brands",
          parenttype: "Product"
        }
        d.push(y)
        // d = [...d,...res]
      }
      // res.selected = this.check_selected(res)
    })
    this.modal.dismiss(d)
  }

  // async get_selected_brands(data){

  //   let brand = {
  //     brand_name:data.brand_name,
  //     brand:data.name
  //   }
  //   await this.modal.dismiss({datas:brand})

  // }

  check_parent(eve,obj){
    this.db.get_product_brands.map(res => {
        res.name == obj.name ? res.selected = true : res.selected = false;
      })
    // obj.selected = obj.selected ? false : true;
    this.save_value()
    // console.log(obj);
  }

}
